import { createAction } from '@reduxjs/toolkit'
import { useLocation } from 'react-router-dom'

import { LOCATION_CHANGE } from './types'

export type Location = ReturnType<typeof useLocation>

export const LocationChangeAction = createAction<Location>(LOCATION_CHANGE)
